import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const getAllStresses = () => {
  return axiosInstance.get(`${URLS.externalRequests}/agro/stresses/`);
};

const getEnemiesOfSpecificStress = (stressId) => {
  return axiosInstance.get(
    `${URLS.externalRequests}/agro/stresses/${stressId}/enemies/`,
    {}
  );
};

export const stressesApi = {
  fetchAll: getAllStresses,
  fetchEnemies: getEnemiesOfSpecificStress,
};
